/* Gilded & Co. — minimal theme behaviour. No dependencies. */
(function () {
  'use strict';

  /* ---- Mobile navigation -------------------------------------------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var burger = header.querySelector('[data-burger]');
    if (burger) {
      burger.addEventListener('click', function () {
        var open = header.getAttribute('data-open') === 'true';
        header.setAttribute('data-open', String(!open));
        burger.setAttribute('aria-expanded', String(!open));
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.getAttribute('data-open') === 'true') {
        header.setAttribute('data-open', 'false');
        if (burger) burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---- Reveal on scroll ---------------------------------------------- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll('[data-reveal]');

  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach(function (el, i) {
      var group = el.parentElement;
      var siblings = group ? group.querySelectorAll(':scope > [data-reveal]') : [];
      var index = Array.prototype.indexOf.call(siblings, el);
      el.style.setProperty('--reveal-delay', (index > 0 ? Math.min(index, 5) * 90 : 0) + 'ms');
      io.observe(el);
    });
  }

  /* ---- Contact routes fill the form subject ---------------------------- */
  var routes = document.querySelectorAll('[data-route]');
  var subject = document.querySelector('[data-contact-subject]');

  routes.forEach(function (card) {
    card.addEventListener('click', function () {
      var wanted = card.getAttribute('data-route');

      routes.forEach(function (other) { other.classList.remove('is-chosen'); });
      card.classList.add('is-chosen');

      if (subject) {
        var matched = Array.prototype.find.call(subject.options, function (opt) {
          return opt.text.trim() === wanted;
        });
        if (matched) subject.value = matched.value;
      }

      var form = document.getElementById('gilded-contact') || subject;
      if (form) {
        form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        var name = form.querySelector ? form.querySelector('input[name="contact[name]"]') : null;
        if (name) window.setTimeout(function () { name.focus({ preventScroll: true }); }, reduce ? 0 : 500);
      }
    });
  });


  /* ---- Contact routes prefill the form subject --------------------------- */
  document.querySelectorAll('[data-contact-subject]').forEach(function (card) {
    card.addEventListener('click', function () {
      var select = document.querySelector('[data-contact-select]');
      if (!select) return;
      var wanted = card.getAttribute('data-contact-subject');
      Array.prototype.forEach.call(select.options, function (opt) {
        if (opt.value === wanted) select.value = opt.value;
      });
    });
  });

  /* ---- Floating booking button ------------------------------------------ */
  var bookingBar = document.querySelector('[data-booking-bar]');
  if (bookingBar) {
    var trigger = document.querySelector('.portal, .section');
    var showAfter = function () {
      var past = window.scrollY > (window.innerHeight * 0.75);
      var atBottom = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 240);
      bookingBar.classList.toggle('is-visible', past && !atBottom);
    };
    showAfter();
    window.addEventListener('scroll', showAfter, { passive: true });
    window.addEventListener('resize', showAfter);
  }

  /* ---- Live cart count ------------------------------------------------ */
  function paintCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
      node.hidden = count < 1;
    });
  }

  document.addEventListener('gilded:cart-updated', function (e) {
    if (e.detail && typeof e.detail.item_count === 'number') paintCount(e.detail.item_count);
  });

  window.gildedRefreshCart = function () {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paintCount(cart.item_count);
        return cart;
      })
      .catch(function () { /* leave the server-rendered count in place */ });
  };
})();
